import instantSms from '@/api/instantSms'
import helpers from '@/utils/helpers'

const state = {
  loading: false,
  error: null,
  domains: [],
  setting: null,
  sends: [],
  send: null,
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_DOMAINS(state, domains) {
    state.domains = domains
  },
  SET_SETTING(state, setting) {
    state.setting = setting
  },
  SET_SENDS(state, sends) {
    state.sends = sends
  },
  SET_SEND(state, send) {
    state.send = send
  },
}

const actions = {
  async fetchDomains({ commit }) {
    return await instantSms
      .fetchDomains()
      .then((response) => {
        commit('SET_DOMAINS', response.data.data)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
      })
  },

  async fetchSetting({ commit }, domainId) {
    commit('SET_LOADING', true)
    return await instantSms
      .fetchSetting(domainId)
      .then((response) => {
        commit('SET_SETTING', response.data.data)
        commit('SET_LOADING', false)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
      })
  },

  async updateSetting({ commit }, { domainId, payload }) {
    commit('SET_LOADING', true)
    return await instantSms
      .updateSetting(domainId, payload)
      .then((response) => {
        commit('SET_SETTING', response.data.data)
        commit('SET_LOADING', false)
        return response.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
        // Field errors for the view; axios only toasts the generic message.
        return error.response?.data
      })
  },

  async fetchSends({ commit }, data) {
    commit('SET_LOADING', true)
    return await instantSms
      .fetchSends(data)
      .then((response) => {
        commit('SET_SENDS', response.data.data)
        commit('SET_LOADING', false)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
      })
  },

  async fetchSend({ commit }, id) {
    commit('SET_SEND', null)
    return await instantSms
      .fetchSend(id)
      .then((response) => {
        commit('SET_SEND', response.data.data)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
      })
  },

  async resendSend({ commit }, id) {
    return await instantSms
      .resendSend(id)
      .then((response) => response.data)
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
